import { TFunction } from "i18next";
import { number, object, string } from "yup";

export const mainSettingsSchema = (t: TFunction) =>
  object({
    title: string().required(t("page.titleCheck")),
    url: string()
      .required(t("folder.urlRequired"))
      .max(255, t("page.urlLong"))
      .matches(/^[A-Za-z0-9-_]+$/, t("page.urlCheck")),
    folderId: number(),
    domainId: number(),
    seoTitle: string().max(60, t("page.seoTitleLong")),
    seoDescription: string().max(160, t("page.seoDescriptionLong")),
    seoKeyWords: string().max(60, t("page.seoKeywordsLong")),
  });
